import React from "react";

const ExternalLinkIcon = ({
    size = 24,
    color = "#6458F1",
    className = "",
    style = {},
}) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 512 512"
        width={size}
        height={size}
        fill={color}
        className={className}
        style={style}
        aria-hidden="true"
    >
        {/* Arrow shaft and head pointing top-right */}
        <path d="M320 0v64h91.627L182.627 293l45.254 45.254L457 109.255V192h64V0H320z" />
        {/* Square/box with open top-right */}
        <path d="M416 448H64V96h176V32H64C28.654 32 0 60.654 0 96v352c0 35.346 28.654 64 64 64h352c35.346 0 64-28.654 64-64V272h-64v176z" />
    </svg>
);

export default ExternalLinkIcon;